module.exports = __webpack_public_path__ + "img/line-completed.3d839408.svg";